module.exports = __webpack_public_path__ + "img/charging-station-infographic.88783c33.webp";